import { render } from "./ThemePalettesClone.vue.js?vue&type=template&id=2b9a69a5!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesClone.vue?vue&type=template&id=2b9a69a5"
import script from "./ThemePalettesClone.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesClone.vue?vue&type=script&lang=js"
export * from "./ThemePalettesClone.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesClone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/ThemePalettesClone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b9a69a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b9a69a5', __exports__)) {
    api.reload('2b9a69a5', __exports__)
  }
  
  module.hot.accept("./ThemePalettesClone.vue.js?vue&type=template&id=2b9a69a5!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesClone.vue?vue&type=template&id=2b9a69a5", () => {
    api.rerender('2b9a69a5', render)
  })

}


export default __exports__